/* eslint-disable */
export default {
  account: 'Account',
  contact: 'Contactpersoon',
  lead: 'Lead',
  opportunity: 'Kans',
  case: 'Geval',
  chooseEntity: 'Selecteer entiteitstype',
  create: 'Maken',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
